import { createContext } from "react";
import { ResultsMenuStoreMobile } from "@state/stores/results";

export const ResultsMenuStoreMobileContext = createContext(
	{} as ResultsMenuStoreMobile
);
